import * as React from 'react';
import { Link } from 'gatsby';
import './NavMenu.styles.scss';

const links = [
  { label: 'Getting Started', path: '/getting-started' },
  { label: 'SDK Reference', path: '/sdk_ref' },
  { label: 'Glossary', path: '/glossary/phenix-glossary-of-terms' },
];

/**
 * Renders a menu for the main nav bar on desktop
 */
export const NavMenu = () => {
  return (
    <div id="desktop-menu" className="flex align-center">
      {links.map(({ label, path }, index) => (
        <Link key={index} to={path}>
          {label}
        </Link>
      ))}
    </div>
  );
};
